// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IdeaIndustryIn = zod.object({
  "industry_id": zod.union([zod.uuid(),zod.null()])
});

export type IdeaIndustryIn = zod.input<typeof IdeaIndustryIn>;
export type IdeaIndustryInOutput = zod.output<typeof IdeaIndustryIn>;
